<template>
    <div>
        <form ref="$form" style="display:none;" :action="action_path" method="post" target="uploadform"
            enctype="multipart/form-data">
            <input ref="$ufiles" type="file" @change="fileupload" name="uploadFile">
            <input type="text" name="FileName" :value="filename" style="display:none">
            <input type="text" name="DirectName" :value="directname" style="display:none">
        </form>
        <iframe ref="$iframe" name="uploadform" style="display:none;"></iframe>
        <van-button v-show="showtitle" @click="show" size="small" type="info">{{ titlename }}</van-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showdia: false,
        }
    },
    props: {
        filename: {
            type: String,
            default: ''
        },
        actionpath: {
            type: String,
            default: ''
        },
        titlename: {
            type: String,
            default: '上传文件'
        },
        directname: {
            type: String,
            default: '',
        },
        showtitle: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        action_path() {
            return this.actionpath || '/api/side/Storage/index';
        },
    },
    mounted() {
        let __self = this;
        __self.$refs.$iframe.onload = function () {
            if (!this.contentDocument) {
                return
            }
            const data = this.contentDocument.body.innerText;
            if (data && data != '') {
                __self.$emit('filepath', data);
                __self.$toast.success("上传成功");
            } else {
                // $utils.fail(data);
            }
        }
    },
    methods: {
        show() {
            let __self = this;
            __self.$refs.$ufiles.click();
        },
        fileupload() {
            let __self = this;
            // __self.$refs.$form.submit();
            // __self.$refs.$ufiles.value = ''
            const fileInput = __self.$refs.$ufiles;
            const file = fileInput.files[0];
            if (file) {
                const allowedTypes = [
                    'image/jpeg',
                    "image/jpg",
                    'image/png',
                    'image/gif',
                    'application/pdf',
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "text/plain",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                    "application/vnd.ms-powerpoint",
                ]; // 根据需要修改允许的文件类型
                if (!allowedTypes.includes(file.type)) {
                    __self.$toast.fail("暂不支持此文件类型上传！");
                    fileInput.value = ''; // 清空文件输入
                    return;
                }
                __self.$refs.$form.submit();
                fileInput.value = '';
            }
        },
    },
}

</script>